import { CheckCircleIcon } from '@heroicons/react/20/solid'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Highlight } from 'react-instantsearch'

import useSafireIdMap from '@components/hooks/useSafireIdMap'
import NavTooltip from '@components/navigation/NavTooltip'

import { isCourseNew } from '@src/utils/safireUtils'

import { AlgoliaCourseHit } from './Search'

type Props = {
  hit: AlgoliaCourseHit
}

export default function CourseHit({ hit }: Props) {
  const { t } = useTranslation('revamp')
  const isNew = isCourseNew(hit)

  const safireIdMap = useSafireIdMap()

  const sanityMatch = safireIdMap.get(hit.Id)

  const tags = [...(sanityMatch ? [t(sanityMatch.type)] : []), ...(isNew ? [t('new')] : [])]

  const hasGuaranteedSessions = hit.SessionsConfirmed.length > 0

  return (
    <a href={hit.url} className='w-full h-full group'>
      <article className='py-4 lg3:py-3 relative leading-none'>
        {tags.length > 0 && (
          <div className='flex items-center gap-1 mb-1'>
            {tags.map((tag) => (
              <NavTooltip key={`hit_${hit.Id}_tag_${tag}`}>{tag}</NavTooltip>
            ))}
          </div>
        )}{' '}
        {hasGuaranteedSessions && (
          <div className='absolute top-3 right-0 flex items-center gap-1'>
            <span className='text-white text-xs leading-none hidden lg3:inline-block'>
              {t('sessions')}
            </span>
            <CheckCircleIcon className='w-5 h-5' style={{ color: '#E14B4B' }} />
          </div>
        )}
        <h4
          className='font-bold mb-2 group-hover:underline multiline-ellipsis-2'
          style={{ maxWidth: '90%' }}
        >
          <Highlight
            attribute='Name'
            hit={hit}
            highlightedTagName={'span'}
            classNames={{ highlighted: 'group-hover:underline italic' }}
          />
        </h4>
        <p className='multiline-ellipsis-2'>
          <Highlight
            className='pb-1'
            attribute='MetaDescription'
            hit={hit}
            highlightedTagName={'span'}
            classNames={{ highlighted: 'italic' }}
          />
        </p>
      </article>
    </a>
  )
}
